"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureContent = exports.deleteContent = exports.updateContent = exports.readContent = exports.createContent = exports.payload = void 0;

var _path = _interopRequireDefault(require("path"));

var _base = _interopRequireDefault(require("base-64"));

var _utf = _interopRequireDefault(require("utf8"));

var _helpers = require("../../../../components/file/helpers");

var _ = require("../..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

;
;
;

var payload = function payload(_ref) {
  var branch = _ref.branch,
      new_branch = _ref.new_branch,
      content = _ref.content,
      message = _ref.message,
      _ref$author = _ref.author,
      email = _ref$author.email,
      username = _ref$author.username,
      sha = _ref.sha;
  return {
    branch: branch,
    new_branch: new_branch,
    content: _base.default.encode(_utf.default.encode(content || '')),
    message: message,
    author: {
      email: email,
      name: username
    },
    sha: sha
  };
}; // POST /api/v1/repos/{owner}/{repo}/contents/{filepath}


exports.payload = payload;

var createContent = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
    var config, owner, repo, branch, filepath, content, message, author, url, contentObject, _payload, response, _payload2, _response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = _ref2.config, owner = _ref2.owner, repo = _ref2.repo, branch = _ref2.branch, filepath = _ref2.filepath, content = _ref2.content, message = _ref2.message, author = _ref2.author;
            url = _path.default.join(_.apiPath, 'repos', owner, repo, 'contents', filepath);
            _context.prev = 2;
            _context.prev = 3;
            _payload = payload({
              branch: branch,
              content: content,
              message: message,
              author: author
            });
            _context.next = 7;
            return (0, _.post)({
              url: url,
              payload: _payload,
              config: config
            });

          case 7:
            response = _context.sent;
            contentObject = response.content;
            _context.next = 18;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            _payload2 = payload({
              new_branch: branch,
              content: content,
              message: message,
              author: author
            });
            _context.next = 16;
            return (0, _.post)({
              url: url,
              payload: _payload2,
              config: config
            });

          case 16:
            _response = _context.sent;
            contentObject = _response.content;

          case 18:
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t1 = _context["catch"](2);
            throw new Error('Error creating file.');

          case 23:
            ;
            return _context.abrupt("return", contentObject);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 20], [3, 11]]);
  }));

  return function createContent(_x) {
    return _ref3.apply(this, arguments);
  };
}();

exports.createContent = createContent;
; // GET /api/v1/repos/{owner}/{repo}/contents/{filepath}?ref={branch}

var readContent = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
    var owner, repo, ref, filepath, config, url, contentObject;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            owner = _ref4.owner, repo = _ref4.repo, ref = _ref4.ref, filepath = _ref4.filepath, config = _ref4.config;
            url = _path.default.join(_.apiPath, 'repos', owner, repo, 'contents', filepath);
            _context2.prev = 2;
            _context2.next = 5;
            return (0, _.get)({
              url: url,
              config: config,
              params: {
                ref: ref
              },
              noCache: true
            });

          case 5:
            contentObject = _context2.sent;
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);
            throw new Error('Error reading file.');

          case 11:
            ;
            return _context2.abrupt("return", contentObject);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 8]]);
  }));

  return function readContent(_x2) {
    return _ref5.apply(this, arguments);
  };
}(); // PUT /api/v1/repos/{owner}/{repo}/contents/{filepath}


exports.readContent = readContent;

var updateContent = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref6) {
    var config, owner, repo, branch, filepath, content, message, author, sha, url, contentObject, _payload, response, _payload3, _response2;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            config = _ref6.config, owner = _ref6.owner, repo = _ref6.repo, branch = _ref6.branch, filepath = _ref6.filepath, content = _ref6.content, message = _ref6.message, author = _ref6.author, sha = _ref6.sha;
            url = _path.default.join(_.apiPath, 'repos', owner, repo, 'contents', filepath);
            _context3.prev = 2;
            _context3.prev = 3;
            _payload = payload({
              branch: branch,
              content: content,
              message: message,
              author: author,
              sha: sha
            });
            _context3.next = 7;
            return (0, _.put)({
              url: url,
              payload: _payload,
              config: config
            });

          case 7:
            response = _context3.sent;
            contentObject = response.content;
            _context3.next = 18;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](3);
            _payload3 = payload({
              new_branch: branch,
              content: content,
              message: message,
              author: author,
              sha: sha
            });
            _context3.next = 16;
            return (0, _.put)({
              url: url,
              payload: _payload3,
              config: config
            });

          case 16:
            _response2 = _context3.sent;
            contentObject = _response2.content;

          case 18:
            ;
            _context3.next = 24;
            break;

          case 21:
            _context3.prev = 21;
            _context3.t1 = _context3["catch"](2);
            throw new Error('Error updating file.');

          case 24:
            ;
            return _context3.abrupt("return", contentObject);

          case 26:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 21], [3, 11]]);
  }));

  return function updateContent(_x3) {
    return _ref7.apply(this, arguments);
  };
}(); // DELETE /api/v1/repos/{owner}/{repo}/contents/{filepath}?ref={branch}


exports.updateContent = updateContent;

var deleteContent = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref8) {
    var config, owner, repo, branch, filepath, message, author, sha, response, url, _payload;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            config = _ref8.config, owner = _ref8.owner, repo = _ref8.repo, branch = _ref8.branch, filepath = _ref8.filepath, message = _ref8.message, author = _ref8.author, sha = _ref8.sha;
            url = _path.default.join(_.apiPath, 'repos', owner, repo, 'contents', filepath);
            _payload = payload({
              branch: branch,
              message: message,
              author: author,
              sha: sha
            });
            _context4.prev = 3;
            _context4.next = 6;
            return (0, _.del)({
              url: url,
              payload: _payload,
              config: config
            });

          case 6:
            response = _context4.sent;
            _context4.next = 12;
            break;

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](3);
            throw new Error('Error deleting file.');

          case 12:
            ;
            return _context4.abrupt("return", response);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[3, 9]]);
  }));

  return function deleteContent(_x4) {
    return _ref9.apply(this, arguments);
  };
}();

exports.deleteContent = deleteContent;

var ensureContent = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref10) {
    var config, owner, repo, branch, filepath, content, message, author, contentObject, _contentObject, _content;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            config = _ref10.config, owner = _ref10.owner, repo = _ref10.repo, branch = _ref10.branch, filepath = _ref10.filepath, content = _ref10.content, message = _ref10.message, author = _ref10.author;
            _context5.prev = 1;
            _context5.next = 4;
            return readContent({
              owner: owner,
              repo: repo,
              ref: branch,
              filepath: filepath,
              config: config
            });

          case 4:
            contentObject = _context5.sent;

            if (contentObject) {
              _context5.next = 7;
              break;
            }

            throw new Error('File does not exist in branch');

          case 7:
            _context5.next = 29;
            break;

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](1);
            _context5.prev = 11;
            _context5.next = 14;
            return readContent({
              owner: owner,
              repo: repo,
              filepath: filepath,
              config: config
            });

          case 14:
            _contentObject = _context5.sent;
            _context5.next = 17;
            return (0, _helpers.getContentFromFile)(_contentObject);

          case 17:
            _content = _context5.sent;
            _context5.next = 20;
            return updateContent({
              config: config,
              owner: owner,
              repo: repo,
              branch: branch,
              filepath: filepath,
              content: _content,
              message: message,
              author: author,
              sha: _contentObject.sha
            });

          case 20:
            contentObject = _context5.sent;
            _context5.next = 28;
            break;

          case 23:
            _context5.prev = 23;
            _context5.t1 = _context5["catch"](11);
            _context5.next = 27;
            return createContent({
              config: config,
              owner: owner,
              repo: repo,
              branch: branch,
              filepath: filepath,
              content: content,
              message: message,
              author: author
            });

          case 27:
            contentObject = _context5.sent;

          case 28:
            ;

          case 29:
            ;
            return _context5.abrupt("return", contentObject);

          case 31:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 9], [11, 23]]);
  }));

  return function ensureContent(_x5) {
    return _ref11.apply(this, arguments);
  };
}();

exports.ensureContent = ensureContent;